"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _minutesPicker = _interopRequireDefault(require("./minutesPicker"));
var _hoursPicker = _interopRequireDefault(require("./hoursPicker"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// Swap out button for MUI Button need example use case
var TimePicker = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(TimePicker, _PureComponent);
  var _super = _createSuper(TimePicker);
  function TimePicker(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TimePicker);
    _this = _super.call(this, props);
    _this.state = {
      minutesDisplayed: false,
      hoursDisplayed: false
    };
    _this.showHours = _this.showHours.bind((0, _assertThisInitialized2.default)(_this));
    _this.showMinutes = _this.showMinutes.bind((0, _assertThisInitialized2.default)(_this));
    _this.goBack = _this.goBack.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderSwitchButton = _this.renderSwitchButton.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(TimePicker, [{
    key: "goBack",
    value: function goBack() {
      this.setState({
        minutesDisplayed: false,
        hoursDisplayed: false
      });
    }
  }, {
    key: "showMinutes",
    value: function showMinutes() {
      this.setState({
        minutesDisplayed: true
      });
    }
  }, {
    key: "showHours",
    value: function showHours() {
      this.setState({
        hoursDisplayed: true
      });
    }
  }, {
    key: "renderSwitchButton",
    value: function renderSwitchButton() {
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "list-unstyled"
      }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("span", {
        role: "presentation",
        className: "btn picker-switch",
        onClick: this.goBack
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fa fa-clock-o"
      }))));
    }
  }, {
    key: "renderMinutes",
    value: function renderMinutes() {
      return this.state.minutesDisplayed ? /*#__PURE__*/_react.default.createElement(_minutesPicker.default, {
        setSelectedMinute: this.props.setSelectedMinute,
        renderSwitchButton: this.renderSwitchButton
      }) : null;
    }
  }, {
    key: "renderHours",
    value: function renderHours() {
      return this.state.hoursDisplayed ? /*#__PURE__*/_react.default.createElement(_hoursPicker.default, {
        setSelectedHour: this.props.setSelectedHour,
        renderSwitchButton: this.renderSwitchButton
      }) : null;
    }
  }, {
    key: "renderAddControl",
    value: function renderAddControl() {
      return /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn",
        onClick: this.props.addHour
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Glyphicon, {
        glyph: "chevron-up"
      }))), /*#__PURE__*/_react.default.createElement("td", {
        className: "separator"
      }), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn",
        onClick: this.props.addMinute
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Glyphicon, {
        glyph: "chevron-up"
      }))), /*#__PURE__*/_react.default.createElement("td", {
        className: "separator"
      }));
    }
  }, {
    key: "renderSubtractControl",
    value: function renderSubtractControl() {
      return /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn",
        onClick: this.props.subtractHour
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Glyphicon, {
        glyph: "chevron-down"
      }))), /*#__PURE__*/_react.default.createElement("td", {
        className: "separator"
      }), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "btn",
        onClick: this.props.subtractMinute
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Glyphicon, {
        glyph: "chevron-down"
      }))), /*#__PURE__*/_react.default.createElement("td", {
        className: "separator"
      }));
    }
  }, {
    key: "renderPicker",
    value: function renderPicker() {
      // Check if there is minute or hour display is showed
      if (!this.state.minutesDisplayed && !this.state.hoursDisplayed) {
        // Render time picker with 3 row
        // The first row is add control
        // The second row is display time
        // The third row is subtract control
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "timepicker-picker"
        }, /*#__PURE__*/_react.default.createElement("table", {
          className: "table-condensed"
        }, /*#__PURE__*/_react.default.createElement("tbody", null, this.renderAddControl(), /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          className: "btn",
          onClick: this.showHours
        }, /*#__PURE__*/_react.default.createElement("span", {
          role: "presentation",
          className: "timepicker-hour"
        }, this.props.selectedDate.format('h')))), /*#__PURE__*/_react.default.createElement("td", {
          className: "separator"
        }, ":"), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          className: "btn",
          onClick: this.showMinutes
        }, /*#__PURE__*/_react.default.createElement("span", {
          role: "presentation",
          className: "timepicker-minute"
        }, this.props.selectedDate.format('mm')))), /*#__PURE__*/_react.default.createElement("td", {
          className: "separator"
        }), /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
          bsStyle: "primary",
          onClick: this.props.togglePeriod,
          value: this.props.selectedDate.format('A')
        }, this.props.selectedDate.format('A')))), this.renderSubtractControl())));
      }
      return '';
    }
  }, {
    key: "render",
    value: function render() {
      var hourPicker = this.state.hoursDisplayed ? 'hour-picker' : '';
      var minutePicker = this.state.minutesDisplayed ? 'minute-picker' : '';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "timepicker ".concat(hourPicker, " ").concat(minutePicker)
      }, this.renderPicker(), this.renderHours(), this.renderMinutes());
    }
  }]);
  return TimePicker;
}(_react.PureComponent);
TimePicker.propTypes = {
  setSelectedHour: _propTypes.default.func.isRequired,
  setSelectedMinute: _propTypes.default.func.isRequired,
  subtractHour: _propTypes.default.func.isRequired,
  addHour: _propTypes.default.func.isRequired,
  subtractMinute: _propTypes.default.func.isRequired,
  addMinute: _propTypes.default.func.isRequired,
  selectedDate: _propTypes.default.instanceOf(_momentTimezone.default).isRequired,
  togglePeriod: _propTypes.default.func.isRequired
};
var _default = TimePicker;
exports.default = _default;